import { connect } from "react-redux";
import { translate } from "../../../base/i18n/functions";
import { IconSubtitles } from "../../../base/icons/svg";
import AbstractButton from "../../../base/toolbox/components/AbstractButton";
import { setOverflowMenuVisible } from "../../../toolbox/actions.web";
import { toggleSpokenLanguageSelectorDialog } from "../../actions.web";
import { getSpokenLanguage } from "../../functions";
/**
 * Implementation of a button for toggling spoken language popup.
 */
class SpokenLanguageButton extends AbstractButton {
    accessibilityLabel = "translation.spokenLanguageTooltip";
    icon = IconSubtitles;
    label = "translation.spokenLanguage";
    tooltip = "translation.spokenLanguageTooltip";
    /**
     * Handles clicking/pressing the button.
     *
     * @returns {void}
     */
    _handleClick() {
        const { dispatch } = this.props;
        dispatch(setOverflowMenuVisible(false));
        dispatch(toggleSpokenLanguageSelectorDialog());
    }
    /**
     * Returns the current spoken language as part of the label.
     *
     * @returns {string}
     */
    _getLabel() {
        return "translation.spokenLanguage";
    }
}
/**
 * Maps (parts of) the redux state to the associated props for the
 * {@code SpokenLanguageButton} component.
 *
 * @param {Object} state - The Redux state.
 * @returns {IProps}
 */
function mapStateToProps(state) {
    return {
        _spokenLanguage: getSpokenLanguage(state),
        visible: true,
    };
}
export default translate(connect(mapStateToProps)(SpokenLanguageButton));
